export default __webpack_public_path__ + "static/media/step2.01ab2cf4.svg";